// @core/api/endpoints/userprofile/get_banner.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BannerResponse,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * Get banner by ID
 * Retrieves banner metadata and image URL by its ID. Only the profile owner can access their banner details.
 */
export async function GetBanner(
  profile_id: string,
  banner_id: string,
  options?: RequestOptions
): Promise<BannerResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:profile_id/banners/:banner_id`;
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  requestPath = requestPath.replace(':banner_id', encodeURIComponent(banner_id));
  const requestOptions = options;
  return client.get<BannerResponse>(requestPath, { ...requestOptions });
}
